export const TextAnalysisIcon = ({ height, width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      height={height}
      width={width}
      x='0'
      y='0'
      viewBox='0 0 682.667 682.667'
      style={{
        enableBackground: 'new 0 0 512 512',
      }}
      xmlSpace='preserve'
      className=''>
      <g>
        <defs strokeWidth='11' style={{ strokeWidth: '11' }}>
          <clipPath
            id='a'
            clipPathUnits='userSpaceOnUse'
            strokeWidth='11'
            style={{ strokeWidth: '11' }}>
            <path
              d='M0 512h512V0H0Z'
              fill='#000000'
              opacity='1'
              data-original='#000000'
              strokeWidth='11'
              style={{ strokeWidth: '11' }}></path>
          </clipPath>
        </defs>
        <path
          d='M413.5 7.5h-315v497h315z'
          style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
          transform='matrix(1.33333 0 0 -1.33333 0 682.667)'
          fill='#ffffff'
          data-original='#d8d5ed'
          className=''
          opacity='1'
          strokeWidth='11'></path>
        <path
          d='M383.5 7.5h30v497h-30z'
          style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
          transform='matrix(1.33333 0 0 -1.33333 0 682.667)'
          fill='#d1fae5'
          data-original='#bebade'
          className=''
          opacity='1'
          strokeWidth='11'></path>
        <path
          d='M344 303.511H168v148h176z'
          style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
          transform='matrix(1.33333 0 0 -1.33333 0 682.667)'
          fill='#4fc6f5'
          data-original='#4fc6f5'
          className=''
          strokeWidth='11'></path>
        <g
          clipPath='url(#a)'
          transform='matrix(1.33333 0 0 -1.33333 0 682.667)'
          strokeWidth='11'
          style={{ strokeWidth: '11' }}>
          <path
            d='m0 0 52.724 46.27a3.861 3.861 0 0 0 4.892.164l101.525-77.686H0Z'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(168 334.763)'
            fill='#ffbd54'
            data-original='#ffbd54'
            strokeWidth='11'></path>
          <path
            d='M0 0c0-10.447-8.469-18.916-18.916-18.916-10.446 0-18.916 8.469-18.916 18.916 0 10.447 8.47 18.916 18.916 18.916C-8.469 18.916 0 10.447 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(315.215 411.249)'
            fill='#ffd659'
            data-original='#ffd659'
            strokeWidth='11'></path>
          <path
            d='m0 0 53.167 46.218v-74H36.308Z'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(290.833 331.293)'
            fill='#059669'
            data-original='#ffa954'
            className=''
            opacity='1'
            strokeWidth='11'></path>
          <path
            d='M0 0c-5.858 5.857-5.858 15.355 0 21.213l98.288 98.288 21.213-21.213L21.213 0C15.355-5.858 5.857-5.858 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(11.894 185.36)'
            fill='#ffffff'
            data-original='#484b63'
            className=''
            opacity='1'
            strokeWidth='11'></path>
          <path
            d='m0 0-35.454 35.454a4.895 4.895 0 0 0 0 6.92l287.15 287.151c5.656 5.656 14.825 5.656 20.48 0l21.893-21.893c5.656-5.655 5.656-14.824 0-20.48L6.919 0A4.894 4.894 0 0 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(206.19 75.55)'
            fill='#a7f3d0'
            data-original='#ff2c5c'
            className=''
            opacity='1'
            strokeWidth='11'></path>
          <path
            d='m0 0-21.187 21.187c5.656-5.656 5.656-14.825 0-20.48l-287.15-287.152a4.894 4.894 0 0 0-6.919 0l21.187-21.187a4.894 4.894 0 0 1 6.919 0L0-20.479C5.655-14.824 5.655-5.655 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(500.259 383.183)'
            fill='#059669'
            data-original='#e62753'
            className=''
            opacity='1'
            strokeWidth='11'></path>
          <path
            d='m0 0-35.454 35.454a4.895 4.895 0 0 0 0 6.92l17.726 17.727 42.374-42.373L6.919 0A4.894 4.894 0 0 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(206.19 75.55)'
            fill='#4fc6f5'
            data-original='#4fc6f5'
            className=''
            strokeWidth='11'></path>
          <path
            d='m0 0-17.727-17.728a4.894 4.894 0 0 0-6.919 0l21.187-21.186a4.894 4.894 0 0 1 6.919 0l17.727 17.727z'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(209.648 114.465)'
            fill='#3bb3e3'
            data-original='#3bb3e3'
            className=''
            strokeWidth='11'></path>
          <path
            d='M0 0c5.432 49.653 29.571 52.388 29.571 52.388l28.716-28.716S55.562-.478 5.9-5.901C2.551-6.267-.366-3.35 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(144.531 55.25)'
            fill='#ffd659'
            data-original='#ffd659'
            strokeWidth='11'></path>
          <path
            d='m0 0-42.374 42.374 21.187 21.187 42.374-42.374Z'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(456.974 319.417)'
            fill='#4fc6f5'
            data-original='#4fc6f5'
            className=''
            strokeWidth='11'></path>
          <path
            d='m0 0-21.187 21.187L0 42.373l21.187-21.186Z'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(456.974 319.417)'
            fill='#3bb3e3'
            data-original='#3bb3e3'
            className=''
            strokeWidth='11'></path>
          <path
            d='M0 0h-119.18c-6.853 0-12.41 5.557-12.41 12.41v45.18c0 6.853 5.557 12.41 12.41 12.41H0c6.854 0 12.41-5.557 12.41-12.41V12.41C12.41 5.557 6.854 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(475.59 43)'
            fill='#4fc6f5'
            data-original='#4fc6f5'
            className=''
            strokeWidth='11'></path>
          <path
            d='M0 0h-48.008v70H0c6.854 0 12.41-5.557 12.41-12.41V12.41C12.41 5.557 6.854 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(475.59 43)'
            fill='#a7f3d0'
            data-original='#ff2c5c'
            className=''
            opacity='1'
            strokeWidth='11'></path>
          <path
            d='M0 0h-30c6.854 0 12.41-5.557 12.41-12.41v-45.18C-17.59-64.443-23.146-70-30-70H0c6.854 0 12.41 5.557 12.41 12.41v45.18C12.41-5.557 6.854 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(475.59 113)'
            fill='#059669'
            data-original='#e62753'
            className=''
            opacity='1'
            strokeWidth='11'></path>
          <path
            d='M427.582 43h-30v70h30z'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            fill='#b5fcff'
            data-original='#b5fcff'
            strokeWidth='11'></path>
          <path
            d='M0 0c-31.191 31.191-31.191 81.944 0 113.137 31.192 31.192 81.945 31.192 113.138 0 31.191-31.193 31.191-81.946 0-113.137C81.945-31.192 31.192-31.192 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(107.62 290.24)'
            fill='#b5fcff'
            data-original='#b5fcff'
            strokeWidth='11'></path>
          <path
            d='M0 0a80.057 80.057 0 0 1-11.618 9.595C9.539-21.523 6.353-64.357-21.213-91.924c-27.566-27.566-70.401-30.752-101.519-9.595a80.05 80.05 0 0 1 9.594-11.618c31.193-31.192 81.946-31.192 113.138 0C31.191-81.945 31.192-31.192 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none', strokeWidth: '11' }}
            transform='translate(220.757 403.376)'
            fill='#71f6fc'
            data-original='#71f6fc'
            className=''
            strokeWidth='11'></path>
          <path
            d='M0 0v154.26'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(98.5 96.5)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0v-35.5h-315v56'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(413.5 43)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0v162.94'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(413.5 113)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0v-55.06'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(413.5 415.75)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0v112.01h315v-56.5'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(98.5 392.49)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0v7.95'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(98.5 293.18)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-147.85'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(290.85 238.03)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-20.74'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(363 204.7)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-114.52'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(257.52 204.7)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-54.07'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(363 171.37)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-81.19'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(224.19 171.37)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-47.85'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(190.85 138.03)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-24v-24.83'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(192 451.51)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h112.53v148h-120'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(231.47 303.51)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='m0 0 49.95-38.229L86.26-66.01H-9.41'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(240.88 369.52)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0c0-10.447-8.469-18.916-18.916-18.916-10.446 0-18.916 8.469-18.916 18.916 0 10.447 8.47 18.916 18.916 18.916C-8.469 18.916 0 10.447 0 0Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(315.215 411.249)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='m0 0 53.167 46.218v-74H36.308Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(290.833 331.293)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='m0 0-26.37-26.37-65.39-65.4c-5.86-5.86-15.36-5.86-21.22 0-5.85 5.86-5.85 15.36 0 21.21l86.61 86.61 3.41 3.41'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(124.87 277.13)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='m0 0-35.454 35.454a4.895 4.895 0 0 0 0 6.92l287.15 287.151c5.656 5.656 14.825 5.656 20.48 0l21.893-21.893c5.656-5.655 5.656-14.824 0-20.48L6.919 0A4.894 4.894 0 0 0 0 0Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(206.19 75.55)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='m0 0-35.454 35.454a4.895 4.895 0 0 0 0 6.92l17.726 17.727 42.374-42.373L6.919 0A4.894 4.894 0 0 0 0 0Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(206.19 75.55)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='m0 0-42.374 42.374 21.187 21.187 42.374-42.374Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(456.974 319.417)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0c5.432 49.653 29.571 52.388 29.571 52.388l28.716-28.716S55.562-.478 5.9-5.901C2.551-6.267-.366-3.35 0 0Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(144.531 55.25)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='m0 0-14.124-14.125'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(188.462 93.278)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-119.18c-6.853 0-12.41 5.557-12.41 12.41v45.18c0 6.853 5.557 12.41 12.41 12.41H0c6.854 0 12.41-5.557 12.41-12.41V12.41C12.41 5.557 6.854 0 0 0Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(475.59 43)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0h-48.008v70H0c6.854 0 12.41-5.557 12.41-12.41V12.41C12.41 5.557 6.854 0 0 0Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(475.59 43)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M427.582 43h-30v70h30z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
          <path
            d='M0 0c-31.191 31.191-31.191 81.944 0 113.137 31.192 31.192 81.945 31.192 113.138 0 31.191-31.193 31.191-81.946 0-113.137C81.945-31.192 31.192-31.192 0 0Z'
            style={{
              strokeWidth: '11',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
              strokeDasharray: 'none',
              strokeOpacity: '1',
            }}
            transform='translate(107.62 290.24)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'></path>
        </g>
      </g>
    </svg>
  );
};
